import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';

// ----------------------------------------------------------------------

export const PRODUCT_GENDER_OPTIONS = [
  { label: 'Male', value: 'Men' },
  { label: 'Female', value: 'Women' },
  { label: 'Kids', value: 'Kids' },
  { label: 'Unisex', value: 'Unisex' },
  { label: 'Others', value: 'Others' },
];

export const PRODUCT_CATEGORY_OPTIONS = [
  {
    name: 'Restaurants',
    color: 'error',
    variation: 'main',
    icon: 'fluent-emoji-flat:hamburger',
    url: `${paths.shop}?category=Restaurants&`,
    src: `${CONFIG.assetsDir}/assets/images/home/categories/restaurants.webp`,
  },
  {
    name: 'Supermarkets',
    color: 'info',
    variation: 'main',
    icon: 'solar:cart-3-bold-duotone',
    url: `${paths.shop}?category=Supermarkets&`,
    src: `${CONFIG.assetsDir}/assets/images/home/categories/supermarkets.webp`,
  },
  {
    name: 'Pharmacies',
    color: 'warning',
    variation: 'light',
    icon: 'fluent-emoji-flat:pill',
    url: `${paths.shop}?category=Pharmacies&`,
    src: `${CONFIG.assetsDir}/assets/images/home/categories/pharmacies.webp`,
  },
  {
    name: 'Infants',
    color: 'warning',
    variation: 'darker',
    icon: 'fluent-emoji:teddy-bear',
    url: `${paths.shop}?category=Infants&`,
    src: `${CONFIG.assetsDir}/assets/images/home/categories/infants.webp`,
  },
  {
    name: 'Pets',
    color: 'error',
    variation: 'linghter',
    icon: 'fluent-color:paw-24',
    url: `${paths.shop}?category=Pets&`,
    src: `${CONFIG.assetsDir}/assets/images/home/categories/pets.webp`,
  },
  {
    name: 'Clothes',
    color: 'secondary',
    variation: 'lighter',
    icon: 'fluent-emoji-flat:womans-clothes',
    url: `${paths.shop}?category=Clothes&`,
    src: `${CONFIG.assetsDir}/assets/images/home/categories/clothes.webp`,
  },
  {
    name: 'Technology',
    color: 'secondary',
    variation: 'main',
    icon: 'fluent-color:phone-laptop-24',
    url: `${paths.shop}?category=Technology&`,
    src: `${CONFIG.assetsDir}/assets/images/home/categories/technology.webp`,
  },
  {
    name: 'Bookstore',
    color: 'info',
    variation: 'dark',
    icon: 'fluent-color:library-24',
    url: `${paths.shop}?category=Bookstore&`,
    src: `${CONFIG.assetsDir}/assets/images/home/categories/bookstores.webp`,
  },
  {
    name: 'Ironmongery',
    color: 'warning',
    variation: 'main',
    icon: 'fluent-color:wrench-screwdriver-24',
    url: `${paths.shop}?category=Ironmongery&`,
    src: `${CONFIG.assetsDir}/assets/images/home/categories/ironmongery.webp`,
  },
  {
    name: 'Health and beauty',
    color: 'error',
    variation: 'light',
    icon: 'fluent-emoji-flat:lotion-bottle',
    url: `${paths.shop}?category=Health+and+beauty&`,
    src: `${CONFIG.assetsDir}/assets/images/home/categories/health-and-beauty.webp`,
  },
  {
    name: 'Sport and fitness',
    color: 'error',
    variation: 'dark',
    icon: 'fluent-color:sport-24',
    url: `${paths.shop}?category=Sport+and+fitness&`,
    src: `${CONFIG.assetsDir}/assets/images/home/categories/sport-and-fitness.webp`,
  },
  {
    name: 'Apartments and houses',
    color: 'info',
    variation: 'darker',
    icon: 'fluent-color:building-multiple-24',
    url: `${paths.shop}?category=Apartments+and+houses&`,
    src: `${CONFIG.assetsDir}/assets/images/home/categories/apartments-and-houses.webp`,
  },
  {
    name: 'Cars and accessories',
    color: 'success',
    variation: 'main',
    icon: 'fluent-emoji-flat:articulated-lorry',
    url: `${paths.shop}?category=Cars+and+accessories&`,
    src: `${CONFIG.assetsDir}/assets/images/home/categories/cars-and-accessories.webp`,
  },
  {
    name: 'Furniture and home',
    color: 'warning',
    variation: 'dark',
    icon: 'fluent-emoji-flat:chair',
    url: `${paths.shop}?category=Furniture+and+home&`,
    src: `${CONFIG.assetsDir}/assets/images/home/categories/furniture-and-home.webp`,
  },
  {
    name: 'Musical instruments',
    color: 'error',
    variation: 'darker',
    icon: 'fluent-emoji-flat:violin',
    url: `${paths.shop}?category=Musical+instruments&`,
    src: `${CONFIG.assetsDir}/assets/images/home/categories/musical-instruments.webp`,
  },
  {
    name: 'Shipping service',
    color: 'warning',
    variation: 'light',
    icon: 'fluent-emoji-flat:package',
    url: `/?`,
    src: `${CONFIG.assetsDir}/assets/images/home/categories/shipping-service.webp`,
  },
];

export const PRODUCT_COLOR_OPTIONS = [
  { value: '#000000', label: 'Negro' },
  { value: '#808080', label: 'Grey' },
  { value: '#C0C0C0', label: 'Silver' },
  { value: '#FFFFFF', label: 'White' },
  { value: '#800020', label: 'Burgundy' },
  { value: '#A52A2A', label: 'Brown' },
  { value: '#FF4842', label: 'Red' },
  { value: '#FFA500', label: 'Orange' },
  { value: '#FFD700', label: 'Gold' },
  { value: '#FFFF00', label: 'Yellow' },
  { value: '#F5F5DC', label: 'Beige' },
  { value: '#98FF98', label: 'Light Green' },
  { value: '#00AB55', label: 'Green' },
  { value: '#ADD8E6', label: 'Light Blue' },
  { value: '#1890FF', label: 'Blue' },
  { value: '#000080', label: 'Navy Blue' },
  { value: '#800080', label: 'Purple' },
  { value: '#FF69B4', label: 'Hot Pink' },
];

export const PRODUCT_SIZE_OPTIONS = [
  { value: '7', label: '7' },
  { value: '8', label: '8' },
  { value: '8.5', label: '8.5' },
  { value: '9', label: '9' },
  { value: '9.5', label: '9.5' },
  { value: '10', label: '10' },
  { value: '10.5', label: '10.5' },
  { value: '11', label: '11' },
  { value: '11.5', label: '11.5' },
  { value: '12', label: '12' },
  { value: '13', label: '13' },
];

export const PRODUCT_STOCK_OPTIONS = [
  { value: 'in stock', label: 'In stock' },
  { value: 'low stock', label: 'Low stock' },
  { value: 'out of stock', label: 'Out of stock' },
];

export const PRODUCT_PUBLISH_OPTIONS = [
  { value: 'YES', label: 'Published' },
  { value: 'NO', label: 'Draft' },
];

export const PRODUCT_SORT_OPTIONS = [
  { value: 'featured', label: 'Featured' },
  { value: 'newest', label: 'Newest' },
  { value: 'priceDesc', label: 'Higher prices' },
  { value: 'priceAsc', label: 'Lower prices' },
];

export const PRODUCT_CATEGORY_GROUP_OPTIONS = [
  { group: 'Clothing', classify: ['Shirts', 'T-shirts', 'Jeans', 'Leather', 'Accessories'] },
  { group: 'Tailored', classify: ['Suits', 'Blazers', 'Trousers', 'Waistcoats', 'Apparel'] },
  { group: 'Accessories', classify: ['Shoes', 'Backpacks and bags', 'Bracelets', 'Face masks'] },
];
